export default __webpack_public_path__ + "9b4fa44c5571442de15c903a5dc2f186.svg";